import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {ControlService} from '../../../services/control.service'
import {CustomerService} from '../../../services/customer.service'
import {StaticDataService} from '../../../services/static-data.service'

@Component({
  selector: 'spb-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class ConfirmDialogComponent {
  public customerService = inject(CustomerService)

  public data = inject<{
    id: string;
    message: string;
    title: string;
  }>(MAT_DIALOG_DATA)

  private readonly controlService = inject(ControlService)

  private readonly staticDataService = inject(StaticDataService)


  public unLockAdvice() {
    this.controlService.locked.set(false)
    this.staticDataService.followAdvice$.next('')
  }
}
